import React, { useState, useEffect } from 'react';
import { Button, Container, Row, Col, Form } from 'react-bootstrap';
import { motion } from 'framer-motion';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './HomePage.css';
import Products from './Products';
import BannersAndPromotions from './BannersAndPromotions';
import BlogSection from './BlogSection';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const HomePage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const [formErrors, setFormErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    const errors = {};
    if (!formData.name.trim()) errors.name = 'Name is required';
    if (!formData.email.trim()) {
      errors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = 'Email is invalid';
    }
    if (!formData.message.trim()) errors.message = 'Message is required';
    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validate();
    if (Object.keys(errors).length === 0) {
      console.log('Form Data:', formData);
      setIsSubmitted(true);
      setFormData({ name: '', email: '', message: '' });
    } else {
      setFormErrors(errors);
    }
  };

  return (
    <div>
      {/* Hero Section */}
      <div
        className="hero-section text-white text-center py-5"
        style={{ backgroundColor: '#1998f3', position: 'relative' }}
      >
        <div
          className="floating-shape shape1"
          style={{
            position: 'absolute',
            top: '20%',
            left: '10%',
            width: '150px',
            height: '150px',
            background: 'rgba(2, 45, 105, 0.3)',
            borderRadius: '50%',
            animation: 'float 6s infinite ease-in-out',
          }}
        ></div>
        <div
          className="floating-shape shape2"
          style={{
            position: 'absolute',
            bottom: '15%',
            right: '20%',
            width: '200px',
            height: '200px',
            background: 'rgba(11, 20, 189, 0.3)',
            borderRadius: '50%',
            animation: 'float 8s infinite ease-in-out',
          }}
        ></div>

        <Container className="d-flex flex-column align-items-center justify-content-center">
          <motion.h1
            className="display-3 fw-bold mb-3"
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            style={{ animation: 'fadeInDown 1s ease-out' }}
          >
            {t('welcome')}  {/* Use translation key */}
          </motion.h1>

          <motion.p
            className="lead mb-4"
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.5 }}
            style={{ animation: 'fadeInUp 1s ease-out' }}
          >
          {t('partner')}  {/* Use translation key */}
          </motion.p>

          <motion.div
            whileHover={{
              scale: 1.1,
              boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.3)',
            }}
            whileTap={{
              scale: 0.95,
              boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.2)',
            }}
            transition={{
              type: 'spring',
              stiffness: 500,
              damping: 15,
            }}
            style={{ display: 'inline-block', animation: 'float 3s ease-in-out infinite' }}
          >
            <Link to="/all-products" style={{ textDecoration: 'none' }}>
              <motion.button
                className="px-5 py-3 rounded-pill shadow"
                style={{
                  background: 'linear-gradient(90deg,rgb(7, 61, 132), #0056b3)',
                  color: '#fff',
                  border: 'none',
                  outline: 'none',
                  fontSize: '1.2rem',
                  fontWeight: '600',
                  letterSpacing: '0.5px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease-in-out',
                }}
                whileHover={{
                  background: 'linear-gradient(90deg, #1cb7ff,rgb(3, 42, 85))',
                  color: '#fff',
                  boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.3)',
                }}
                whileTap={{ scale: 0.95 }}
              >
                Shop Now
              </motion.button>
            </Link>
          </motion.div>
        </Container>
      </div>

      {/* About Us Section */}
      <section id="about" className="py-5" style={{ background: 'linear-gradient(to right, #f8f9fa, #e9ecef)' }}>
        <Container>
          <Row className="align-items-center">
            <Col md={6} className="mb-4 mb-md-0">
              <h3 className="display-4 fw-bold mb-3 text-primary" data-aos="fade-up">{t('title')}</h3>
              <h4 className="text-secondary mb-4" data-aos="fade-up" data-aos-delay="300">{t('subtitle')}</h4>
              <p className="text-muted fs-5" data-aos="fade-up" data-aos-delay="600" dangerouslySetInnerHTML={{ __html: t('description') }} />
              <h4 className="display-4 fw-bold mb-3 text-primary" data-aos="fade-up">{t('title1')}</h4>
              <p className="text-muted fs-5" data-aos="fade-up" data-aos-delay="600" dangerouslySetInnerHTML={{ __html: t('description1') }} />
            </Col>
            <Col md={6} className="text-center">
              <div className="image-wrapper position-relative" data-aos="fade-left">
                <img src="/images/ag1.jpg" alt="About Us" className="img-fluid" style={{ borderRadius: '20px' }} />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Banners and Promotions */}
      <BannersAndPromotions />

      {/* Featured Products */}
      <Products />

      {/* Blog Section */}
      <BlogSection />
{/* Our Products Section */}
      <section className="py-5" style={{ backgroundColor: '#ffffff' }}>
        <div className="container">
          <h2 className="text-center text-primary fw-bold mb-5" data-aos="flip-up">Our Products</h2>
          <div className="row g-4">
            {[
              { title: 'Hdpe Injection Fittings', image: 'https://agpipefitting.org.et/images/hdpe.png' },
              { title: 'Hdpe Fabricated Butt Weld Fittings', image: 'https://agpipefitting.org.et/images/xxx.png' },
              { title: 'PPR Fittings', image: 'https://agpipefitting.org.et/images/PPR.jpg.png' },
              { title: 'Upvc Fittings', image: 'https://agpipefitting.org.et/images/yyy.png' },
              { title: 'Jerrycans', image: 'https://agpipefitting.org.et/images/jery.png' },
              { title: 'Paint Buckets', image: 'https://agpipefitting.org.et/images/paint.png' },
              { title: 'Fiber Products', image: 'https://agpipefitting.org.et/images/fiber.png' },
              { title: 'Stadium Seat', image: 'https://agpipefitting.org.et/images/eee.png' },
            ].map((product, index) => (
              <div key={index} className="col-lg-3 col-md-4 col-sm-6" data-aos="zoom-in">
                <div className="card shadow-sm border-0 rounded-4 h-100 overflow-hidden product-card">
                <img 
              src={product.image} 
              alt={product.title}
              className="card-img-top product-image"
              style={{ height: '200px', width: '300px' }}
            />
                  <div className="card-body text-center p-3">
                    <h5 className="fw-bold mb-0">{product.title}</h5>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Contact Section */}
      <section id="contact" className="py-5" style={{ backgroundColor: "#012e58" }}>
        <Container>
          <Row className="align-items-center">
            <Col md={6} className="text-white" data-aos="fade-right">
              <h2 className="display-4 mb-4">Get in Touch</h2>
              <p className="lead">Have any questions? Reach out to us directly, and we'll be happy to assist you.</p>
              <p><strong>Address:</strong> East Africa , Ethiopia , BahirDar </p>
              <p><strong>Phone:</strong> +251930415372 / 947090514 / 900863252</p>
              <p><strong>Email:</strong> <a href="mailto:info@agpipefitting.com" className="text-primary">agpipefittingtechnology@gmail.com</a></p>
            </Col>
            <Col md={6} data-aos="fade-left">
              <Form onSubmit={handleSubmit} className="bg-white p-4 rounded shadow">
                <Form.Group className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control type="text" name="name" placeholder="Enter your full name" value={formData.name} onChange={handleChange} />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control type="email" name="email" placeholder="Enter your email" value={formData.email} onChange={handleChange} />
                </Form.Group>
                <Button type="submit" variant="primary" className="btn-lg w-100">
                  Send Message
                </Button>
              </Form>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default HomePage;
